import React, { Component } from 'react';
import { GradientPage } from '../../components';
import { multiLanguage } from '../../hoc';

const bgImg = 'https://lagunaproperty.com/images/47249213-H1-ANVNLC_FH_0612_AN_Two_Bedroom_Loft_8615.jpg';

@multiLanguage()
class Section4 extends Component {
  render() {
    const { t } = this.props;
    return (
      <div className="section4">
        <GradientPage image={bgImg}>
          <div className="text" dangerouslySetInnerHTML={{ __html: t('Priority wait list on reservations') }} />
        </GradientPage>
      </div>
    );
  }
}

export default Section4;



// WEBPACK FOOTER //
// ./src/pages/SanctuaryClub/Section4.js